import React, { useState, useRef,useEffect,useCallback } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Link } from "react-router-dom";
import { useHeaderFilters } from '../../context/HeaderFilterContext';
import CommonSelect from "../../core/common/commonSelect";
import type { Option } from "../../core/common/commonSelect";
import api from "../../api";
import { DatesSetArg } from '@fullcalendar/core';
import { useParams, useNavigate } from "react-router-dom";
import { encryptQuery,decryptQuery } from "../../utils/encryption";
import Footer from "../../Footer";
import moment from 'moment';
import LeaveModal from "./LeaveModal";
import {  useSelector } from "react-redux";
import { useFilterData } from "../../context/FilterContext";
import { toast,ToastContainer } from 'react-toastify';


 
const LeaveCalendar = () => {
  const { setFilters } = useHeaderFilters();
  const navigate = useNavigate();
  const { encryptedQuery } = useParams<{ encryptedQuery?: string }>();
  const { filtersData } = useFilterData();

const dataLayout    = useSelector((state: any) => state.themeSetting.dataLayout)
    const expandedWidth  = 40
    const collapsedWidth =  72
    const sidebarWidth = dataLayout === 'mini_layout'
                         ? collapsedWidth
                         : expandedWidth

  const [loggedInUserId, setLoggedInUserId] = useState<string | null>(null);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [currentView, setCurrentView] = useState<{ start: string; end: string; type: string } | null>(null);
  const [events, setEvents] = useState<any[]>([]);
  const calendarRef = useRef<FullCalendar>(null);
  const [employeesFilter, setEmployeesFilter] = useState<Employee[]>([]);
   const [statusFilter, setStatusFilter] = useState<{ value: string; label: string }[]>([]);
   const [employeesForm, setEmployeesForm] = useState<Employee[]>([]);
   const [selectedStatus, setSelectedStatus] = useState<string | null>("0"); // "0" = All Status
   const [selectedUserId, setSelectedUserId] = useState<number | null>(0);
   const [todayLeaves, setTodayLeaves] = useState<number | null>(0);
   const [unapprovedLeaves, setUnapprovedLeaves] = useState<number | null>(0);
   const [totalLeaves, setTotalLeaves] = useState<number | null>(0);
    const [leaveRequests, setLeaveRequests] = useState<LeaveDetailsItem[]>([]);
    const [isMobile, setIsMobile] = useState(false);
    const [isReportingHead, setIsReportingHead] = useState(false);
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const initialRole = storedUser?.role_name ?? null;
    const [userRole, setUserRole] = useState<number | null>(initialRole);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const modalRefRequest = useRef<HTMLDivElement | null>(null);
    const [validationErrors, setValidationErrors] = useState<any>({});
    const [leaveErrorMessage, setLeaveErrorMessage] = useState<string>("");

  interface Employee {
    id: number;
    name: string;
    [key: string]: any;
}

    const [leaveDetails, setLeaveDetails] = useState<LeaveDetails>({
        showModal1: false,
        isEditMode: false,
        leaveType: undefined,
        leaveDuration: "",
        singleDate: "",
        startDate: "",
        endDate: "",
        halfShortDate: "",
        halfDayType: "",
        reason: "",
        status: "",
        disableAllFields: false,
        disableAllExceptStatus: false,
        leaveAppliedDate: "",
        selectedEmployeeId: parseInt(loggedInUserId || "0"),
        users: employeesForm,
      });

    useEffect(() => {
        if (isModalOpen && modalRefRequest.current) {
          const modal = new window.bootstrap.Modal(modalRefRequest.current);
          modal.show();
      
          modalRefRequest.current.addEventListener('hidden.bs.modal', () => {
            setIsModalOpen(false);
          });
        }
      }, [isModalOpen]);


useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  interface LeaveFilterDataResponse {
    leave_status: {
      [key: number]: string;
    };
    filter_employees: Employee[];
    names: Employee[];
    reporting_head_flag: boolean;
  }

useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const loggedInUserId = String(storedUser?.id);
    setLoggedInUserId(loggedInUserId)
  }, []); // run once on mount

  useEffect(() => {
       if (filtersData && Object.keys(filtersData).length > 0) {
        const allEmployeesOption = {
            id: 0,
            name: "All Employees",
            image_url: "",
          };
          const updatedEmployeesFilter = [
            allEmployeesOption,
            ...filtersData?.filter_employees,
          ];
  
          const allStatusOption = {
            value: "0",
            label: "All Status",
          };
  
          const statusOptions = [
            allStatusOption,
            ...Object.entries(filtersData?.leave_status).map(([key, value]) => ({
              value: key,
              label: String(value), 
            })),
          ];
      
        setEmployeesFilter(updatedEmployeesFilter);
        setStatusFilter(statusOptions);
        setEmployeesForm(filtersData?.names);
        setSelectedUserId(0);
        setIsReportingHead(filtersData?.reporting_head_flag); 
      }
    }, [filtersData]);

  interface LeaveDetailsItem {
    id: number;
    user_id: number;
    designation_title: string;
    user_name: string;
    image_url: string;
    reporting_head_id: number;
    duration: string;
    start_date: string;
    end_date: string | null;
    status: number;
    half: number;
    leave_type: number;
  }
  
   interface LeaveApiResponse {
    leavedetails: {
      current_page: number;
      data: LeaveDetailsItem[];
      total:number;
    };
    todayLeaves:number;
    unVerifiedLeaves:number;
    totalLeaves:number;
  }
  
   const fetchLeaveRequests = useCallback(async () => {
    let fromDate: string, toDate: string;
  
    if (selectedDate) {
      fromDate = toDate = selectedDate;
    } else if (currentView) {
      const fromDateObj = new Date(currentView.start);
      fromDate = fromDateObj.toISOString().split("T")[0];
  
      const toDateObj = new Date(currentView.end);
      toDateObj.setDate(toDateObj.getDate() - 1);
      toDate = toDateObj.toISOString().split("T")[0];
    } else {
      return;
    }

    try {
      const apiUrl = userRole === 1 ? "/filter-leaves" : "/filter-leaves-employee";

      const payload = {
        employee: selectedUserId,
        status: selectedStatus,
        fromDate:fromDate, 
        toDate:toDate,
      };

      const response: LeaveApiResponse = await api(apiUrl, {
        method: "POST",
        body: payload,
      });

      const leaveRecords = response.leavedetails.data || [];

      const leaveEvents = leaveRecords.flatMap((record) => {
        const eventsPerDay = [];
        const start = new Date(record.start_date);
        const end = new Date(record.end_date || record.start_date);

        for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
          const dateStr = new Date(d).toISOString().split("T")[0];
          eventsPerDay.push({
            id: `${record.id}-${dateStr}`,
            title: record.user_name,
            start: dateStr,
            end: dateStr,
            allDay: true,
            extendedProps: {
              ...record,
            },
          });
        }

        return eventsPerDay;
      });

      console.log("leaveEvents:", leaveEvents);
      setEvents(leaveEvents);

      setLeaveRequests(response.leavedetails.data);
      setTodayLeaves(response.todayLeaves);
      setUnapprovedLeaves(response.unVerifiedLeaves);
      setTotalLeaves(response.totalLeaves);
    } catch (error) {
      console.error("Failed to fetch leave requests:", error);
    }
  }, [userRole, selectedUserId, selectedStatus,currentView,selectedDate]);



useEffect(() => {
    if (currentView && userRole !== null && selectedUserId !== null) {
      fetchLeaveRequests();
    }
}, [currentView, selectedUserId, selectedStatus, fetchLeaveRequests, userRole]);
  

useEffect(() => {
  if (encryptedQuery && employeesFilter.length) {
    try {
      const decoded = decodeURIComponent(encryptedQuery);
      const result = decryptQuery(decoded);

      if (result && typeof result === 'object') {
        const data = result as LeaveRequestFilterParams;
        const userExists = employeesFilter.some(emp => emp.id === data.selectedUserId);
        setSelectedUserId(userExists ? data.selectedUserId : 0);        
        setSelectedStatus(data.selectedStatus || "0");
        return;
      }
    } catch (e) {
      console.warn("Failed to decrypt query:", e);
    }
  }

  if (!encryptedQuery) {
    const saved = localStorage.getItem("LeaveCalendarFilters");
    if (saved) {
      navigate(`/leave-calendar/${encodeURIComponent(saved)}`, { replace: true });
    }
  }

  // Fallback if no encrypted query or decryption fails
  setSelectedUserId(0);
  setSelectedStatus("0");
}, [encryptedQuery,employeesFilter,navigate]);

interface LeaveRequestFilterParams {
    selectedUserId: number | null;
    selectedStatus: string | null;
}

const defaultLeaveRequestFilters: LeaveRequestFilterParams = {
  selectedUserId: 0,
  selectedStatus: "0",
};

const areLeaveRequestFiltersDefault = (filters: LeaveRequestFilterParams) => {
  return (
    (filters.selectedUserId ?? 0) === defaultLeaveRequestFilters.selectedUserId &&
    (filters.selectedStatus ?? "0") === defaultLeaveRequestFilters.selectedStatus 
  );
};

const updateFilterUrl = (
  filters: LeaveRequestFilterParams,
  baseRoute: string = "/leave-calendar"
) => {
  if (areLeaveRequestFiltersDefault(filters)) {
    // If filters are default, reset to base route
    navigate(baseRoute, { replace: false });
    localStorage.removeItem("LeaveCalendarFilters");
  } else {
    const encrypted = encryptQuery(filters);
    localStorage.setItem("LeaveCalendarFilters",encrypted);
    const encoded = encodeURIComponent(encrypted);
    navigate(`${baseRoute}/${encoded}`, { replace: false });
  }
};

const handleUserChange = (userId: number | null) => {
    setSelectedUserId(userId);

    updateFilterUrl({
      selectedUserId: userId,
      selectedStatus,
    });
  };

  const handleStatusChange = (status: string | null) => {
    setSelectedStatus(status|| "0");
    console.log("handleStatusChange selectedUserId:", selectedUserId);

    updateFilterUrl({
      selectedUserId,
      selectedStatus:status,
    });
};

const handleLeaveError = useCallback((errorMessage: string) => {
  console.log("Received error in Leave.tsx:", errorMessage);
  setLeaveErrorMessage(errorMessage);
  setTimeout(() => {
    setLeaveErrorMessage("");
  }, 1000);
}, []);

const handleDatesSet = (arg: DatesSetArg) => {
  document.querySelectorAll("button.fc-dayGridMonth-button").forEach(button => {
  button.classList.remove("fc-dayGridMonth-button");
  button.classList.add("fc-button");
  button.classList.add("fc-button-primary");
  });
  
  getCurrentRange();
};
  
  const getCurrentRange = () => {
    const calendarApi = calendarRef.current?.getApi();
    const view = calendarApi?.view;
  
    if (view) {
      const start = new Date(view.currentStart);
      start.setDate(start.getDate() + 1);
  
      const end = new Date(view.currentEnd);
      end.setDate(end.getDate() + 1);
  
      setCurrentView({
        start: start.toISOString(),
        end: end.toISOString(),
        type:view.type
      });
    }
  };

  const handleReset = () => {  
    setSelectedUserId(0);
    setSelectedStatus("0")
    localStorage.removeItem("LeaveCalendarFilters");
    navigate(`/leave-calendar`, { replace: false });
  };

useEffect(() => {
    const isResetVisible =
      (selectedUserId && String(selectedUserId) !== "null") ||
      (selectedStatus && String(selectedStatus) !== "0");

    const showUserSelect = userRole === 1 || (userRole === 2 && isReportingHead);
    console.log("isReportingHead:", isReportingHead);
  
    const FiltersDesktop = () => (
      <div className="px-2 px-md-2">
        <div className="attendance-filters d-flex align-items-center flex-wrap">
        <div className="d-flex align-items-center border bg-white rounded p-1 icon-list toggle-att-mobile" style={{ left: sidebarWidth, position: "absolute" }}>
        <Link to="/leave/leave-request" className="btn btn-icon btn-sm">
          <i className="ti ti-list-details" />
        </Link>
        <Link to="/leave-calendar" className="btn btn-icon btn-sm me-1 active bg-primary text-white">
          <i className="ti ti-calendar-event" />
        </Link>
        <Link to="/leave/leave-balance" className="btn btn-icon btn-sm">
          <i className="ti ti-beach" />
        </Link>
      </div>

  
          <div className="d-flex align-items-center gap-2">
            {isResetVisible && (
              <button
              className="btn add_btn_size btn-outline-primary"
              onClick={handleReset}
              title="Reset"
              >
              <i className="ti ti-refresh" />
            </button>
            )}
            {showUserSelect && (
              <CommonSelect
              className="select"
              options={employeesFilter.map(emp => ({
                value: emp.id.toString(),
                label: emp.name,
              }))}
              value={
                employeesFilter
                  .map(emp => ({
                    value: emp.id.toString(),
                    label: emp.name,
                  }))
                  .find(opt => opt.value === selectedUserId?.toString()) 
              }
              onChange={(selectedOption: Option | null) => {
                const selectedId = selectedOption?.value || "0";
                console.log("Selected User ID:", selectedId);
                handleUserChange(parseInt(selectedId)); // still convert to number if needed
              }}
                                
            />
                 
            )}

<div className="status-dropdown-wrapper">
  <CommonSelect
    className="select"
    options={statusFilter}
    value={statusFilter.find(option => option.value === selectedStatus)}
    onChange={(selectedOption: Option | null) => {
      const selected = selectedOption?.value || "0";
      handleStatusChange(selected);
    }}
  />
</div>


          </div>
        </div>
      </div>
    );
  

const FiltersMobile = () => {
  const [showModal, setShowModal] = useState(false);
  const modalRef = useRef<HTMLDivElement | null>(null);

  // Close modal on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        setShowModal(false);
      }
    };

    if (showModal) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showModal]);

  return (
    <div className="px-2 px-md-2">
      <div className="attendance-filters-mobile d-flex align-items-center justify-content-between gap-2">

        {/* View toggle */}
        <div className="d-flex align-items-center border bg-white rounded p-1 icon-list toggle-att-mobile">
          <Link to="/leave/leave-request" className="btn btn-icon btn-sm">
            <i className="ti ti-list-details" />
          </Link>
          <Link to="/leave-calendar" className="btn btn-icon btn-sm me-1 active bg-primary text-white">
            <i className="ti ti-calendar-event" />
          </Link>
          <Link to="/leave/leave-balance" className="btn btn-icon btn-sm">
            <i className="ti ti-beach" />
          </Link>
      </div>

        {/* Reset + Datepicker */}
        <div className="d-flex align-items-center gap-2">
          {isResetVisible && (
            <button
            className="btn add_btn_size btn-outline-primary"
            onClick={handleReset}
            title="Reset"
            >
            <i className="ti ti-refresh" />
            </button>
          )}
          
        </div>

        {/* Filter Modal Trigger */}
            <button className="btn btn-outline-primary add_btn_size" onClick={() => setShowModal(true)}>
              <i className="ti ti-filter" />
            </button>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-backdrop" style={{
          position: 'fixed',
          top: 0, left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.3)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start', 
          paddingTop: '103px', 
          zIndex: 1050,
        }}>
          <div
            ref={modalRef}
            className="bg-white p-3 rounded shadow"
            style={{ width: '90%', maxWidth: '400px' }}
          >

{showUserSelect && (
              <CommonSelect
              className="select"
              options={employeesFilter.map(emp => ({
                value: emp.id.toString(),
                label: emp.name,
              }))}
              value={
                employeesFilter
                  .map(emp => ({
                    value: emp.id.toString(),
                    label: emp.name,
                  }))
                  .find(opt => opt.value === selectedUserId?.toString()) 
              }
              onChange={(selectedOption: Option | null) => {
                const selectedId = selectedOption?.value || "0";
                console.log("Selected User ID:", selectedId);
                handleUserChange(parseInt(selectedId)); // still convert to number if needed
              }}
                   forceFullWidth={isMobile}             
            />
                 
            )}

            <div className="status-dropdown-wrapper">
              <CommonSelect
                className="select mt-2"
                options={statusFilter}
                value={statusFilter.find(option => option.value === selectedStatus)}
                onChange={(selectedOption: Option | null) => {
                  const selected = selectedOption?.value || "0";
                  handleStatusChange(selected);
                }}
                forceFullWidth={isMobile}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
  
    setFilters(isMobile ? <FiltersMobile /> : <FiltersDesktop />);
  
    return () => setFilters(null);
  }, [
    isMobile,
    setFilters,
    isReportingHead,
    selectedUserId,
    selectedStatus,
    employeesFilter,
    statusFilter
  ]);
  
  useEffect(() => {
    setTimeout(() => {
      getCurrentRange();
    }, 0); // Wait till calendar is rendered
  }, []);

  interface LeaveDetails {
    showModal1: boolean;
    isEditMode: boolean;
    editId?: number;
    leaveType: number|undefined;
    leaveDuration: string;
    singleDate: string;
    startDate: string;
    endDate: string;
    halfShortDate: string;
    halfDayType: string;
    reason: string;
    status: string;
    disableAllFields: boolean;
    disableAllExceptStatus: boolean;
    userId?: number;
    leaveAppliedDate: string;
    users: Employee[]
    selectedEmployeeId: number|undefined;
    validationErrors?: any;
    currentPage?: number;
    pageSize?: number;
  }

  interface LeaveEditResponse {
    duration: string;
    half: number;
    from_date: string;
    to_date?: string;
    reason?: string;
    leave_type?: number;
    status: number;
    user_id: number;
    created_at: string;
  }

  const isDateInPast = (date: string) => {
      return moment(date).isBefore(moment(), "day");
    };

  const formatDate = (date: string) => (date ? moment(date, "YYYY-MM-DD").format("DD-MMM-YYYY") : "");
  const formatLeaveAppliedDate = (date: string) => (date ? moment(date).format("DD-MMM-YYYY hh:mm A") : "");


  const handleEdit = async (leaveRequest: any) => {
    const { id } = leaveRequest;
    setIsModalOpen(true)
  
    try {
      const response = await api<LeaveEditResponse>(`/edit-leave-request/${id}`, {
        method: "GET",
      });
      
      const data = response;    
  
      let leaveDuration = "";
      if (data.duration === "1") leaveDuration = "single";
      else if (data.duration === "0.5") leaveDuration = "half";
      else if (data.duration === "0.25") leaveDuration = "short";
      else if (parseInt(data.duration) > 1) leaveDuration = "multi";
  
      let half = "";
      if (data.half === 1) half = "first-half";
      else if (data.half === 2) half = "second-half";
  
      const isSingleDatePast = isDateInPast(data.from_date);
      const isEndDatePast = data.to_date ? isDateInPast(data.to_date) : false;
  
      const disableAllExceptStatus = userRole === 2 && data.status === 2;

      const localDisableAllFields =
        disableAllExceptStatus
          ? true
          : [3, 5].includes(data.status) ||
            (data.status === 4 &&
              isSingleDatePast &&
              (!data.to_date || isEndDatePast) &&
              (userRole === 1 || userRole === undefined)) ||
            ((data.status === 4 || data.status === 2) &&
              userRole === 2 &&
              (!data.to_date || isEndDatePast));
  
        console.log("selectedUserId leave:", data.user_id );
  
      setLeaveDetails({
        showModal1: true,
        isEditMode: true,
        editId: id,
        leaveType: data.leave_type || undefined,
        leaveDuration,
        singleDate: formatDate(data.from_date),
        startDate: formatDate(data.from_date),
        endDate: formatDate(data.to_date ?? ""),
        halfShortDate: formatDate(data.from_date),
        halfDayType: half,
        reason: data.reason || "",
        status: String(data.status) || "",
        disableAllFields: localDisableAllFields,
        disableAllExceptStatus,
        userId: data.user_id || 0,
        leaveAppliedDate: formatLeaveAppliedDate(data.created_at),
        users:employeesForm,
        selectedEmployeeId:selectedUserId?? 0,
        validationErrors,
      });
    } catch (error) {
      console.error("Error fetching leave request:", error);
    }
  };

  const closeModal = useCallback(() => {
    setIsModalOpen(false)
    console.log("closemodal called:", isModalOpen);
    setLeaveDetails({} as LeaveDetails);
  }, []);

  const handleEventClick = (info: any) => {
    const leaveRequest = info.event.extendedProps;
    console.log("leaveRequest:", leaveRequest);
    handleEdit(leaveRequest);
  };

  const stats = [
    { title: "Today", value: todayLeaves },
    { title: "Total", value: totalLeaves },
    { title: "Pending", value: unapprovedLeaves },
  ];

  const colSize = `col-lg-${12 / stats.length} col-${12 / stats.length}`;

  return (
    <>
  <div className="page-wrapper">
    <div className="content">
       <div className="row custom-leave-boxes">
          {stats.map((item, index) => (
            <div key={index} className={colSize}>
              <div className="card flex-fill att-card">
                <div className="card-body d-flex align-items-center justify-content-between box-padding boxes-att-mobile">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <p
                        className={`fs-16 mb-1 text-truncate att-boxes-title`}
                      >
                        {item.title}
                      </p>
                      <h3 className="mb-0 att-boxes-value">{item.value}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

          <div className="row custom-leave-boxes">
            {/* Calendar Sidebar */}
            <div className="col-xxl-9 col-xl-9 theiaStickySidebar calendar-padding leave-bottom">
              <div className="stickybar">
                <div className="card border-0 att-card">
                  <div className="card-body calendar-spacing">
                    <FullCalendar
                      plugins={[
                        dayGridPlugin,
                        timeGridPlugin,
                        interactionPlugin,
                      ]}
                      initialView="dayGridMonth"
                      events={events}
                      headerToolbar={{
                        start: "today,prev,next",
                        center: "title",
                        end: "dayGridMonth,dayGridWeek,dayGridDay",
                      }}
                      eventClick={handleEventClick}
                      ref={calendarRef}
                      datesSet={handleDatesSet}
                      navLinks={true}
                      views={{
                        dayGridMonth: {
                          dayMaxEvents: 3, // only applies in month view
                          moreLinkHint: "Show all leave requests",
                        },
                        timeGridWeek: {
                          dayMaxEvents: false, // no limit in week view
                        },
                        timeGridDay: {
                          dayMaxEvents: false,
                        },
                      }}                      
                      eventContent={(arg) => {
                        const record = arg.event.extendedProps as LeaveDetailsItem;
                        const { user_name, image_url, duration, leave_type, status, half } = record;
                        const currentViewName = calendarRef.current?.getApi().view.type;                    
                
                        const statusColors: Record<number, { background: string; color: string }> = {
                          1: { background: "#CD8B015E", color: "#A87C20" },
                          2: { background: "#AFC2FF", color: "#3F4D92" },
                          3: { background: "#FF060661", color: "#C24242" },
                          4: { background: "#9FF4C4", color: "#34714E" },
                          5: { background: "#FF060661", color: "#C24242" },
                        };

                        const numericDuration = Number(duration);
                
                        const styles = {
                          backgroundColor: statusColors[status]?.background,
                          color: statusColors[status]?.color,
                          display: "flex",
                          alignItems: "center",
                          padding: "2px 4px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          width: numericDuration === 0.5 ? "50%" : numericDuration === 0.25 ? "25%" : "100%",
                          marginLeft: half === 2 ? "auto" : undefined,
                        };
                
                        return (
                          <div style={styles} title={user_name}>
                            {image_url && (
                              <img
                                src={image_url}
                                alt={user_name}
                                style={{ width: "16px", height: "16px", borderRadius: "50%", marginRight: "4px" }}
                              />
                            )}
                            <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {(numericDuration === 0.25 && currentViewName !== 'dayGridDay') ? "" : user_name}
                            </span>
                            {leave_type === 2 && (
                              <i className="fas fa-house-laptop" style={{ marginLeft: "5px",flexShrink:"0" }}></i>
                            )}
                          </div>
                        );
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* /Calendar Sidebar */}
            <div className="col-xxl-3 col-xl-3 theiaStickySidebar">
              <div className="stickybar">
                <div className="card att-card">
                  <div className="card-body p-3 calendar-spacing">
                    {/* Event */}
                    <div className="">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h5 className="font-light">LEGENDS</h5>
                      </div>
                      <div id="external-events">
                        <div
                          className="fc-event fc-leave bg-sanctioned mb-1 font-light"
                          data-event='{ "title": "Sanctioned" }'
                          data-event-classname="bg-transparent-Sanctioned"
                        >
                          Sanctioned
                        </div>
                        <div
                          className="fc-event fc-leave bg-approved mb-1 font-light"
                          data-event='{ "title": "Approved" }'
                          data-event-classname="bg-transparent-Approved"
                        >
                          Approved
                        </div>
                        <div
                          className="fc-event fc-leave bg-pending mb-1 font-light"
                          data-event='{ "title": "Pending" }'
                          data-event-classname="bg-transparent-Pending"
                        >
                          Pending
                        </div>
                        <div
                          className="fc-event fc-leave bg-rejected mb-1 font-light"
                          data-event='{ "title": "Rejected/Revoked" }'
                          data-event-classname="bg-transparent-Rejected"
                        >
                          Rejected/Revoked
                        </div>
                      </div>
                    </div>
                    {/* /Event */}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div>
          <Footer />
        </div>
      </div>
      {/* /Page Wrapper */}

      <LeaveModal
        leaveDetails={leaveDetails}
        isOpen={isModalOpen}
        onClose={closeModal}
        onError={handleLeaveError}
        fetchLeaveRequests={fetchLeaveRequests}
        userRole={userRole??0}
      ><></></LeaveModal>
      <ToastContainer position="top-right" autoClose={3000} />
    </>

  );
};

export default LeaveCalendar;
